import { useState } from "react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api } from "@/lib/api";
import { usePoll } from "@/hooks/usePoll";
import { fmtMoney, fmtSigned, fmtDateTime, pnlClass, SIDE, ORDER_TYPE, ORDER_STATUS } from "@/lib/format";
import { PageHeader, StatusBadge, Empty } from "@/components/kit";
import { LiveMarketGrid, ChartDialog } from "@/components/LiveMarketGrid";
import { MarketHeatmap } from "@/components/MarketHeatmap";

const VIEWS = { open: "Posições abertas", closed: "Posições encerradas", orders: "Ordens" };

export default function AdminTrading() {
  const [view, setView] = useState("open");
  const [rows, setRows] = useState([]);
  const [chart, setChart] = useState(null);
  usePoll(() => api.get(view === "orders" ? "/admin/orders" : `/admin/positions?status=${view}`).then((r) => setRows(r.data)).catch(() => {}), 10000, [view]);
  return (
    <div data-testid="admin-trading-page">
      <PageHeader eyebrow="Negociação" title="Investimentos e operações" desc="Acompanhe o mercado ao vivo e consulte posições e o histórico de ordens de todos os clientes (modo demonstração)." />
      <MarketHeatmap onSelect={setChart} />
      {chart && <ChartDialog a={chart} onClose={() => setChart(null)} />}
      <LiveMarketGrid />
      <Tabs value={view} onValueChange={setView} className="mb-5"><TabsList>{Object.entries(VIEWS).map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`admin-trading-tab-${k}`}>{l}</TabsTrigger>)}</TabsList></Tabs>
      <div className="surface overflow-x-auto">
        <table className="w-full text-sm" data-testid="admin-trading-table">
          <thead><tr className="text-left eyebrow border-b border-border">
            <th className="py-3 pl-5">Data</th><th>Cliente</th><th>Ativo</th><th>Lado</th><th className="text-right">Qtd</th>
            {view === "orders" ? <><th>Tipo</th><th className="text-right">Preço</th><th>Status</th></> : <><th className="text-right">Entrada</th><th className="text-right">{view === "open" ? "Atual" : "Saída"}</th><th className="text-right pr-5">Resultado</th></>}
          </tr></thead>
          <tbody>{rows.map((r) => (
            <tr key={r.id} className="border-b border-border">
              <td className="py-3 pl-5 text-xs text-muted-foreground">{fmtDateTime(r.created_at || r.opened_at)}</td>
              <td><div>{r.user_name}</div><div className="num text-xs text-primary">{r.client_code}</div></td>
              <td>{r.name || r.symbol}</td><td className={r.side === "buy" ? "up" : "down"}>{SIDE[r.side]}</td><td className="text-right num">{r.quantity}</td>
              {view === "orders" ? <><td>{ORDER_TYPE[r.order_type]}</td><td className="text-right num">{r.fill_price || r.requested_price || "—"}</td><td><StatusBadge map={ORDER_STATUS} value={r.status} /></td></>
                : <><td className="text-right num">{r.entry_price}</td><td className="text-right num">{view === "open" ? r.current_price : r.exit_price}</td>
                  <td className={`text-right num pr-5 ${pnlClass(view === "open" ? r.unrealized_pnl : r.net_pnl)}`}>{fmtSigned(view === "open" ? r.unrealized_pnl : r.net_pnl, r.account_currency || "USD")}<div className="text-xs text-muted-foreground">margem {fmtMoney(r.margin, r.account_currency || "USD")}</div></td></>}
            </tr>))}</tbody>
        </table>
        {rows.length === 0 && <Empty text="Sem registros." />}
      </div>
    </div>
  );
}
